import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=f61fc718&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=f61fc718&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f61fc718",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f61fc718')) {
      api.createRecord('f61fc718', component.options)
    } else {
      api.reload('f61fc718', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=f61fc718&scoped=true&", function () {
      api.rerender('f61fc718', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2KeL37xhwSoQv/JS/comp/DocBox.vue"
export default component.exports